import { useState, useCallback } from 'react';
import { useDebounce } from './useDebounce';

/**
 * Hook that provides search functionality with debouncing
 * @param defaultValue - Default search value
 * @param debounceMs - Debounce delay in milliseconds (default: 300)
 * @returns Search state and functions
 */
export function useSearch(defaultValue = '', debounceMs = 300) {
  const [searchQuery, setSearchQuery] = useState(defaultValue);
  const debouncedSearchQuery = useDebounce(searchQuery, debounceMs);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
  }, []);

  const handleSearchChange = useCallback((value: string) => {
    setSearchQuery(value);
  }, []);

  return {
    searchQuery,           // Immediate value for input display
    debouncedSearchQuery,  // Debounced value for filtering
    setSearchQuery: handleSearchChange,
    clearSearch,
    hasSearch: searchQuery.length > 0
  };
}